module.exports = __webpack_public_path__ + "assets/img/relate_pda_login.f4ae938d.png";